import React from "react";

import "./Blog.css";
import NavLight from "../../components/NavLight";
import BlogsPreview from "../../components/BlogsPreview";
import FoundersGuide from "../../components/FoundersGuide";
import {CustomMetaHelmet} from "../../components/CustomMetaHelmet";
import {meta} from "../../assets/meta/meta";

function IntroducingMagicAISurveys() {
  return (
    <div className="Blog1">
      <CustomMetaHelmet meta={meta['introducing-magic-ai-surveys']}/>
      <NavLight />
      <section className="blog-page">
        <article className="blog-page-container">
          <div>
            <h1>Introducing Magic AI Surveys</h1>
            <p>
              <iframe
                width="702"
                height="405"
                src="https://www.youtube.com/embed/P9scxvomgAU?si=oh2HyFdZEJ2yn6CQ"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </p>
          </div>
        </article>
      </section>
      <section className="related-blogs">
        <h1> You might also like</h1>
        <BlogsPreview />
      </section>
      <section className="FoundersGuide">
        <FoundersGuide />
      </section>
    </div>
  );
}

export default IntroducingMagicAISurveys;
